import { Controller } from "react-hook-form"
import { Lens } from "@hookform/lenses"
import { SpecialtySelect } from "@/modules/patients/detail/progress-note/components/specialty-select"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"

type SpecialtyContentProps = {
  specialtyLens: Lens<PointOfCareFormType["specialtyId"]>
  onSpecialtySelect?: (specialty: PointOfCareFormType["specialtyId"]) => void
}

export const SpecialtyContent = ({ specialtyLens, onSpecialtySelect }: SpecialtyContentProps) => {
  const { control, name } = specialtyLens.interop()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <SpecialtySelect
          onClear={() => field.onChange(null)}
          defaultValue={field.value?.word ?? ""}
          onSelect={(specialty) => {
            field.onChange(specialty)
            onSpecialtySelect?.(specialty)
          }}
          error={!!fieldState.error?.message}
        />
      )}
    />
  )
}
